import dashboardRequest from '@/pages/dashboard/utils/dashboardRequest';
import http from '@/utils/http';

// 指标少选起
export const getMetricsOptions: (data: any) => Promise<any> = (data) => {
  const options = {
    url: `/api/v1/dashboard/pc/benchmark/select`,
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};


export const getGameList: (api: string, data: any) => Promise<any> = (api, data) => http({
  url: api,
  method: 'post',
  data,
});


export const getGTDRSelectorList: (api: string | undefined, data: any) => Promise<any> = (api, data) => http({
  url: api || `/api/v1/dashboard/pc/gtdr/select`,
  method: 'post',
  data,
});

export const getPerformanceList: (data: any, api: string) => Promise<any> = (data, api) => http({
  url: api || `/api/v1/dashboard/pc/gtdr/benchmark/performance`,
  method: 'post',
  data,
});